import docLinks from '@/utils/config/docLinks'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.config.globalProperties.$docsUrl = import.meta.env.VUE_APP_DOCS_URL
    app.config.globalProperties.$docLinks = docLinks
    window.$docLinks = docLinks
  },
}
